


























import { component as AssetManagerComposer } from '@/composers/asset-manager';
import LoaderInline from '@/components/LoaderInline.vue';

export default AssetManagerComposer({
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    // is the area highlighted (for drag/drop)
    highlight: false,
  }),
  computed: {
    updatingAsset() {
      return this.assetComposerAssets.find((asset: any) => (
        asset.uploadId || asset.removing
      ));
    },
  },
  methods: {
    fileDrag(event: any, highlight: boolean) {
      if (this.isDisabled) {
        return;
      }

      this.highlight = highlight;
      event.preventDefault();
      event.stopPropagation();

      const { files } = event.dataTransfer;

      // upload on drop
      files.length
        && event.type === 'drop'
        && this.assetComposerUpload(files);
    },
  },
  components: {
    LoaderInline,
  },
} as IView);
